<template>
  <div>
    <b-form-group
      label="Makbuz"
      label-for="is_receipt"
    >
      <b-form-radio-group
        id="is_receipt"
        v-model="dataItem.is_receipt"
        :options="options"
        @change="setReceiptNo"
      />
    </b-form-group>
  </div>
</template>

<script>
import {
  BFormGroup, BFormRadioGroup,
} from 'bootstrap-vue'

export default {
  name: 'Receipt',
  components: {
    BFormGroup,
    BFormRadioGroup,
  },
  data() {
    return {
      options: [
        {
          text: 'Makbuz Kesildi',
          value: '1',
        },
        {
          text: 'Makbuz Kesilmedi',
          value: '0',
        },
      ],
    }
  },
  computed: {
    dataItem() {
      return this.$store.getters['accountActivities/dataItem']
    },
  },
  methods: {
    setReceiptNo(item) {
      if (item === '0') {
        this.dataItem.receipt_no = null
      }
    },
  },
}
</script>
